

import Swiper from 'swiper/bundle';

var galleryThumbs = new Swiper(".gallery-page-thumbs", {

  speed: 1500,
  mousewheel: true,
  scrollbar: {
    el: ".gallery-scrollbar",
    hide: false,

  },

  breakpoints: {
    0: {
      slidesPerView: 3,
      spaceBetween: 10

    },
    768: {
      spaceBetween: 30,
      slidesPerView: 5,

    },
  },



});

var galleryTop = new Swiper(".gallery-page-swiper", {
  loop: true,
  spaceBetween: 14,
  speed: 1500,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  thumbs: {
    swiper: galleryThumbs,
  },
  navigation: {
    nextEl: ".swiper-gallery-button-next",
    prevEl: ".swiper-gallery-button-prev",
  },
  pagination: {
    el: ".gallery-pagination",
    type: "fraction",
    renderFraction: function (currentClass) {
      return '0<span class="' + currentClass + '"> </span>';
    },

  },

});
